import { useDispatch } from 'react-redux';
import * as $ from 'jquery';
import { orderEdit, orderLoad } from '../../../redux/actions/order/orderActions';
import { examLoad, examUpdate } from '../../../redux/actions/exam/examActions';
import { patientReportsLoad } from '../../../itrust_common/redux/actions/settingActions/patientReportActions';
import { claimFormLoad } from '../../../redux/actions/order/claimFormActions';
import { tabChange } from '../../../itrust_common/redux/actions/otherActions';
import { currentStoreLoad, storeStaffsLoad } from '../../../redux/actions/currentStoreActions';
import { procedurePricingsLoad } from '../../../redux/actions/storeSettings/ProcedurePricingActions';
import { handleStopExamRecording } from '../exam/CommonFunctions';
import { visionInsuranceClaimFormLoad } from '../../../redux/actions/addOns/rpa/vision_insurance/visionInsuranceClaimFormAction';

export default function EditOrderButton(props) {
  const { orderId, storeId, children, order, isTelemedExam } = props;
  const dispatch = useDispatch()

  const loadStoreDependencies = (storeId) => {
    let localStorageStoreId = localStorage.getItem('StoreID')
    if (!localStorageStoreId) {
      dispatch(currentStoreLoad())
      dispatch(procedurePricingsLoad({ rpp: 99999, filter: { for_store: storeId }, include: ['procedures'] }))
    }
    if ((localStorageStoreId && localStorageStoreId !== 'null') || storeId) {
      // list all staffs despite from their designation
      dispatch(storeStaffsLoad(localStorageStoreId || storeId, { rpp: 1000, filter: {} }))
    }
  }

  const handleExamStopSaveRecording = async (exam) => {
    const res = await handleStopExamRecording()
    res && dispatch(examUpdate({ id: exam.id, telemed_visits_attributes: [res] }, { include: '*' }))
  }

  const handleOrderEdit = async (storeId, id) => {
    loadStoreDependencies(storeId)
    dispatch(orderEdit(id));
    dispatch(tabChange({ order: 1 }))
    let res = await dispatch(orderLoad(id, { direction: "desc", sort: "created_at", include: '*' }))
    res = res.value.data.order
    handleClaimFormLoad(id, res)
    if (res.exam_examination_id) {
      //Load associated exam
      dispatch(examLoad(res.exam_examination_id, { include: '*' })).then((res) => isTelemedExam && handleExamStopSaveRecording(res.value.data.exam))
    }
    //Invoice report template
    dispatch(patientReportsLoad({ patient_id: res.patient_attributes.id, staff_id: res.staff_id, store_id: res.store_attributes.id, filter: { category: "invoice" } }))
    setTimeout(function () {
      $('#editExamForm-modal').modal('hide');
      $('#orderForm-modal').modal('show');
    }, 1000)
  }

  const handleClaimFormLoad = (id, order) => {
    if (order.vision_insurance_claim_exist) {
      dispatch(visionInsuranceClaimFormLoad(id))
    }
    else {
      dispatch(claimFormLoad(id))
    }
  }


  return (
    <span
      className="pointer"
      onClick={() => handleOrderEdit(storeId, orderId)}
    >
      {children}
    </span>
  )
}
